export const SET_LOCATIONS_DATA = 'SET_LOCATIONS_DATA';
export const setLocationsData = (data, count) => ({
  type: SET_LOCATIONS_DATA,
  payload: { data, count }
});